export const getMarkClassName = (key) => {
  return `passengerDetails${key}`
}
